export default __webpack_public_path__ + "static/media/logo-qr-icon.478fcdff.png";